import script from "./downLoadDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./downLoadDialog.vue?vue&type=script&lang=ts&setup=true"

import "./downLoadDialog.vue?vue&type=style&index=0&id=4306e611&lang=scss"

const __exports__ = script;

export default __exports__